'use strict';

angular.module('atex.dam').directive('damMailInputText', [
  'DamDistributionListService',
  '$timeout',
  function(
    DamDistributionListService,
    $timeout
  ) {
  return {
    restrict : 'EA',
    
    templateUrl : 'views/dam-mail-text-input.html',
    
    replace : true,
    require: '?ngModel',
    scope : {
      disabled: "=",
      model : '=ngModel',
      removeResults:'=',
      addDistributionLists:'=',
      useGroups:'='
    },

    controller: function ($scope) {
      $scope.tags = [];

      if ($scope.addDistributionLists) {
        $timeout(function() {
          DamDistributionListService.getDistributionLists({type: 'email'}).then(function (data) {
            if (data && data.groups && $scope.useGroups) {
              _.each(_.map(data.groups, function (g) {
                return {
                  id: g,
                  text: g,
                  type: 'group'
                };
              }), function (i) {
                $scope.tags.push(i);
              });
            }
            if (data && data.users) {
              _.each(_.map(data.users, function (u) {
                return {
                  id: u,
                  text: u,
                  type: 'user'
                };
              }), function (i) {
                $scope.tags.push(i);
              });
            }
          }).then(null, function (error) {
            console.log(error);
          });
        });
      }
    },
    
    link : function(scope, element, attrs, ngModel) {

      function format(tag) {
        if (tag.type === 'group') {
          return "<i class='fa fa-group'></i>&nbsp;" + tag.text;
        } else if (tag.type === 'user') {
          return "<i class='fa fa-user'></i>&nbsp;" + tag.text;
        } else {
          return "<i class='fa fa-user'></i>&nbsp;" + tag.text;
        }
      }

      var obj = element.find('.form-control');
      obj.select2({
        tags: function () {
          return scope.tags;
        },
        formatResult: format,
        formatSelection: format,
        selectOnBlur: true,
        multiple: true,
        tokenSeparators: [',', ', ', ';', ' ']
      });

      if ((scope.model !== undefined) && (scope.model.length !== undefined) && (scope.model.length > 0)) {
        angular.forEach(scope.model, function(entry, key) {
          if ( (entry !== null) && (entry !== "") ) {
            scope.tags.push({
              id : entry,
              text : entry,
              type: 'user'
            });
          }
        });
      }

      obj.select2('data', scope.tags);
      if(scope.disabled) {
        obj.select2('disable', true);
      }

      if (scope.removeResults) {
        $('.select2-results').remove();
      }
      
      obj.on("change", function(e) {
    	  if(e && e.removed) {
    		  angular.forEach(scope.tags, function(tag, key) {
    			  if( e.removed.id === tag.id ) {
              //scope.tags.splice(key,1);
    			  }
    		  });
    	  }

        ngModel.$setViewValue(e.val);

      });
    }
  };
} ]);
